if (!customElements.get("product-info")) {
	customElements.define(
		"product-info",
		class ProductInfo extends HTMLElement {
			quantityInput = undefined;
			quantityForm = undefined;
			onVariantChangeUnsubscriber = undefined;
			cartUpdateUnsubscriber = undefined;
			abortController = undefined;
			pendingRequestUrl = null;
			preProcessHtmlCallbacks = [];
			postProcessHtmlCallbacks = [];

			constructor() {
				super();

				this.quantityInput = this.querySelector(".quantity__input");
			}

			connectedCallback() {
				this.initializeProductSwapUtility();

				this.onVariantChangeUnsubscriber = subscribe(
					PUB_SUB_EVENTS.optionValueSelectionChange,
					this.handleOptionValueChange.bind(this)
				);

				this.initQuantityHandlers();
				this.dispatchEvent(
					new CustomEvent("product-info:loaded", { bubbles: true })
				);
			}

			addPreProcessCallback(callback) {
				this.preProcessHtmlCallbacks.push(callback);
			}

			initQuantityHandlers() {
				if (!this.quantityInput) return;

				this.quantityForm = this.querySelector(".product-form__quantity");
				if (!this.quantityForm) return;

				this.setQuantityBoundries();
				if (!this.dataset.originalSection) {
					this.cartUpdateUnsubscriber = subscribe(
						PUB_SUB_EVENTS.cartUpdate,
						this.fetchQuantityRules.bind(this)
					);
				}
			}

			disconnectedCallback() {
				this.onVariantChangeUnsubscriber();
				this.cartUpdateUnsubscriber?.();
			}

			initializeProductSwapUtility() {
				this.preProcessHtmlCallbacks.push((html) =>
					html
						.querySelectorAll(".scroll-trigger")
						.forEach((element) =>
							element.classList.add("scroll-trigger--cancel")
						)
				);
				this.postProcessHtmlCallbacks.push((newNode) => {
					window?.Shopify?.PaymentButton?.init();
					window?.ProductModel?.loadShopifyXR();
				});
			}

			handleOptionValueChange({
				data: { event, target, selectedOptionValues },
			}) {
				if (!this.contains(event.target)) return;
				this.resetProductFormState();

				const productUrl =
					target.dataset.productUrl ||
					this.pendingRequestUrl ||
					this.dataset.url;
				this.pendingRequestUrl = productUrl;
				const shouldSwapProduct = this.dataset.url !== productUrl;
				const shouldFetchFullPage =
					this.dataset.updateUrl === "true" && shouldSwapProduct;
				const requestOptionValues = shouldSwapProduct
					? this.getSelectedOptionValuesForProductSwap(
							target,
							selectedOptionValues
						)
					: selectedOptionValues;

				let callback = this.handleUpdateProductInfo(productUrl);
				if (window.location.pathname.includes("/products/")) {
					callback = shouldSwapProduct
						? this.handleSwapProduct(productUrl, shouldFetchFullPage)
						: this.handleUpdateProductInfo(productUrl);
				}

				this.renderProductInfo({
					requestUrl: this.buildRequestUrlWithParams(
						productUrl,
						requestOptionValues,
						shouldFetchFullPage
					),
					targetId: target.id,
					callback,
				});
			}

			getSelectedOptionValuesForProductSwap(target, selectedOptionValues) {
				const changedOption = target?.dataset?.optionName;
				const targetSelects = target?.closest("variant-selects");
				if (!changedOption || !targetSelects) return selectedOptionValues;

				const currentSelects = this.querySelector(
					`variant-selects input[data-product-url="${this.dataset.url}"]`
				)?.closest("variant-selects");

				if (!currentSelects) return selectedOptionValues;

				const preserved = Array.from(
					currentSelects.querySelectorAll("input:checked[data-option-name]")
				).reduce((optionIds, input) => {
					if (input.dataset.optionName === changedOption) return optionIds;

					const match = targetSelects.querySelector(
						`input[data-option-name="${input.dataset.optionName}"][value="${input.value}"]`
					);

					if (match?.dataset?.optionValueId)
						optionIds.add(match.dataset.optionValueId);

					return optionIds;
				}, new Set());

				return [...selectedOptionValues, ...preserved];
			}

			resetProductFormState() {
				const productForm = this.productForm;
				productForm?.toggleSubmitButton(true);
				productForm?.handleErrorMessage();
			}

			handleSwapProduct(productUrl, updateFullPage) {
				return (html) => {
					this.productModal?.remove();

					const selector = updateFullPage
						? "product-info[id^='MainProduct']"
						: "product-info";
					const variant = this.getSelectedVariant(html.querySelector(selector));
					if (window.location.pathname.includes("/products/")) {
						this.updateURL(productUrl, variant?.id);
					}

					if (document.body.classList.contains("template-bundle")) {
						document.querySelector("head title").innerHTML =
							html.querySelector("head title").innerHTML;
					}

					if (
						updateFullPage &&
						!document.body.classList.contains("template-bundle")
					) {
						document.querySelector("head title").innerHTML =
							html.querySelector("head title").innerHTML;

						HTMLUpdateUtility.viewTransition(
							document.querySelector("main"),
							html.querySelector("main"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);

						if (location.pathname.includes("/products/")) {
							if (document.querySelector("[js-product-info]")) {
								yotpoWidgetsContainer.initWidgets();
								document.dispatchEvent(new CustomEvent("upsellPDP:init"));
								document.dispatchEvent(new CustomEvent("pdp-accordion:init"));
								document.dispatchEvent(new CustomEvent("stickyAddToCart:init"));
								document.dispatchEvent(
									new CustomEvent("mobile-media-slider:init")
								);
								document.dispatchEvent(
									new CustomEvent("stickyVariantSelect:init")
								);
							}

							if (
								document.querySelector(
									"[js-product-object-image-text-main-new]"
								)
							) {
								setTimeout(() => {
									document.dispatchEvent(
										new CustomEvent("product-object-image-text-sliders:init")
									);
								}, 1000);
							}

							if (
								document.querySelector(
									"[js-product-object-full-looks-main-new]"
								)
							) {
								document.dispatchEvent(
									new CustomEvent("product-object-full-looks-items-slider:init")
								);
							}

							if (
								document.querySelector(
									"[js-index-object-tabs-columns-main-new]"
								)
							) {
								document.dispatchEvent(
									new CustomEvent("indexObjectTabsColumnsSlider:init")
								);
								document.dispatchEvent(
									new CustomEvent("tabsCommonScript:init")
								);
							}
						}
					} else {
						HTMLUpdateUtility.viewTransition(
							this,
							html.querySelector("product-info"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);
						yotpoWidgetsContainer.initWidgets();
						document.dispatchEvent(new CustomEvent("upsellPDP:init"));
						document.dispatchEvent(new CustomEvent("pdp-accordion:init"));
						document.dispatchEvent(new CustomEvent("stickyAddToCart:init"));
						document.dispatchEvent(new CustomEvent("mobile-media-slider:init"));
						document.dispatchEvent(new CustomEvent("stickyVariantSelect:init"));
					}
					document.dispatchEvent(
						new CustomEvent("onvariant:change", {
							detail: { currentVariant: variant },
						})
					);
				};
			}

			renderProductInfo({ requestUrl, targetId, callback }) {
				this.abortController?.abort();
				this.abortController = new AbortController();

				fetch(requestUrl, { signal: this.abortController.signal })
					.then((response) => response.text())
					.then((responseText) => {
						this.pendingRequestUrl = null;
						const html = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						callback(html);
					})
					.then(() => {
						// set focus to last clicked option value
						document.querySelector(`#${targetId}`)?.focus();
					})
					.catch((error) => {
						if (error.name === "AbortError") {
							console.log("Fetch aborted by user");
						} else {
							console.error(error);
						}
					});
			}

			getSelectedVariant(productInfoNode) {
				const selectedVariant = productInfoNode.querySelector(
					"variant-selects [data-selected-variant]"
				)?.innerHTML;
				return !!selectedVariant ? JSON.parse(selectedVariant) : null;
			}

			buildRequestUrlWithParams(
				url,
				optionValues,
				shouldFetchFullPage = false
			) {
				const params = [];

				!shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

				if (optionValues.length) {
					params.push(`option_values=${optionValues.join(",")}`);
				}

				if (
					document.body.classList.contains("template-bundle") ||
					this.closest("[js-quickatc-popup-wrapper]")?.dataset?.bundleProduct ==
						"true"
				) {
					return `${url}?view=bundle&${params.join("&")}`;
				}

				return `${url}?${params.join("&")}`;
			}

			updateOptionValues(html) {
				const variantSelects = html.querySelector("variant-selects");
				if (variantSelects) {
					HTMLUpdateUtility.viewTransition(
						this.variantSelectors,
						variantSelects,
						this.preProcessHtmlCallbacks
					);
					document.dispatchEvent(new CustomEvent("variantDropDown:init"));
				}
				const currentCustomSelects = this.querySelectorAll(
					"custom-variant-selects"
				);
				const newCustomSelects = html.querySelectorAll(
					"custom-variant-selects"
				);
				currentCustomSelects.forEach((current, index) => {
					if (newCustomSelects[index]) {
						HTMLUpdateUtility.viewTransition(current, newCustomSelects[index]);
					}
				});
			}

			handleUpdateProductInfo(productUrl) {
				return (html) => {
					const variant = this.getSelectedVariant(html);

					this.pickupAvailability?.update(variant);
					this.updateOptionValues(html);
					if (window.location.pathname.includes("/products/")) {
						this.updateURL(productUrl, variant?.id);
					}
					this.updateVariantInputs(variant?.id);

					if (!variant) {
						this.setUnavailable();
						let mainProductSection = html.querySelector("[js-product-info]");
						if (mainProductSection) {
							const targetElement = document.querySelector(
								".quickatc-popup__content"
							);
							if (targetElement) {
								targetElement.replaceChildren(mainProductSection);
							}
						}
						return;
					}

					this.updateMedia(html, variant?.featured_media?.id);

					const updateSourceFromDestination = (
						id,
						shouldHide = (source) => false
					) => {
						const source = html.getElementById(`${id}-${this.sectionId}`);
						const destination = this.querySelector(
							`#${id}-${this.dataset.section}`
						);
						if (source && destination) {
							if (id === "price2") {
								const rebuyAddon = document.querySelector(".rebuy-addon");

								if (rebuyAddon) {
									const regularPriceEl = source.querySelector(
										"[js-price-item--sale]"
									);
									const comparePriceEl = source.querySelector(
										"[js-price-item--compare-price]"
									);

									const regularPrice = parseInt(
										regularPriceEl.getAttribute("data-price")
									);

									const rebuyMoneyEl = rebuyAddon.querySelector(
										".rebuy-money span:not([class])"
									);
									const rebuyPriceText = rebuyMoneyEl?.textContent;
									const rebuyPriceNumber =
										parseFloat(rebuyPriceText?.replace(/[^0-9.]/g, "")) * 100;

									if (rebuyAddon.querySelector(".rebuy-checkbox")?.checked) {
										const totalAddonRegularPrice =
											regularPrice + rebuyPriceNumber;
										regularPriceEl.textContent = theme.Currency.formatMoney(
											totalAddonRegularPrice,
											theme.settings.moneyFormat
										).replace(/\.00$/, "");

										if (comparePriceEl) {
											const comparePrice = parseInt(
												comparePriceEl.getAttribute("data-price")
											);
											const totalAddonComparePrice =
												comparePrice + rebuyPriceNumber;

											if (totalAddonComparePrice > totalAddonRegularPrice) {
												comparePriceEl.textContent = theme.Currency.formatMoney(
													totalAddonComparePrice,
													theme.settings.moneyFormat
												).replace(/\.00$/, "");
											}
										}
									}
								}
							}

							destination.innerHTML = source.innerHTML;
							destination.classList.toggle("hidden", shouldHide(source));
						}
					};

					updateSourceFromDestination("price");
					updateSourceFromDestination("price2");
					updateSourceFromDestination("price3");
					updateSourceFromDestination("ProductSubmitButton-sticky");
					updateSourceFromDestination("Location-details");

					updateSourceFromDestination("Sku", ({ classList }) =>
						classList.contains("hidden")
					);
					updateSourceFromDestination(
						"Inventory",
						({ innerText }) => innerText === ""
					);
					updateSourceFromDestination("Volume");
					updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
						classList.contains("hidden")
					);

					this.updateQuantityRules(this.sectionId, html);
					this.querySelector(
						`#Quantity-Rules-${this.dataset.section}`
					)?.classList.remove("hidden");
					this.querySelector(
						`#Volume-Note-${this.dataset.section}`
					)?.classList.remove("hidden");

					this.productForm?.toggleSubmitButton(
						html
							.getElementById(`ProductSubmitButton-${this.sectionId}`)
							?.hasAttribute("disabled") ?? true,
						window.variantStrings.soldOut
					);
					document.dispatchEvent(
						new CustomEvent("onvariant:change", {
							detail: { currentVariant: variant },
						})
					);
					document.dispatchEvent(new CustomEvent("stickyAddToCart:init"));
					publish(PUB_SUB_EVENTS.variantChange, {
						data: {
							sectionId: this.sectionId,
							html,
							variant,
						},
					});
					const customVariantSelectors = document.querySelectorAll(
						"custom-variant-selects"
					);

					customVariantSelectors.forEach((customVariant) => {
						const labels = customVariant.querySelectorAll("label");
						labels.forEach((label) => {
							const optionValue = label.querySelector(".option__value");
							if (optionValue) {
								optionValue.style.opacity = 1;
							}
							const spinner = label.querySelector(".loading__spinner");
							if (spinner) {
								if (!spinner.classList.contains("hidden")) {
									spinner.classList.add("hidden");
								}
							}
						});
					});

					//==================== Affirm
					updateSourceFromDestination("Affirm");
					affirm?.ui?.refresh();
				};
			}

			updateVariantInputs(variantId) {
				this.querySelectorAll(
					`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
				).forEach((productForm) => {
					const input = productForm.querySelector('input[name="id"]');
					input.value = variantId ?? "";
					input.dispatchEvent(new Event("change", { bubbles: true }));
				});
			}

			updateURL(url, variantId) {
				this.querySelector("share-button")?.updateUrl(
					`${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
				);

				if (this.dataset.updateUrl === "false") return;
				window.history.replaceState(
					{},
					"",
					`${url}${variantId ? `?variant=${variantId}` : ""}`
				);
			}

			setUnavailable() {
				this.productForm?.toggleSubmitButton(
					true,
					window.variantStrings.unavailable
				);

				const selectors = [
					"price",
					"Inventory",
					"Sku",
					"Price-Per-Item",
					"Volume-Note",
					"Volume",
					"Quantity-Rules",
				]
					.map((id) => `#${id}-${this.dataset.section}`)
					.join(", ");
				document
					.querySelectorAll(selectors)
					.forEach(({ classList }) => classList.add("hidden"));
			}

			updateMedia(html, variantFeaturedMediaId) {
				if (!variantFeaturedMediaId) return;

				const mediaGallerySource = this.querySelector("media-gallery ul");
				const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

				const refreshSourceData = () => {
					if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
					const mediaGallerySourceItems = Array.from(
						mediaGallerySource.querySelectorAll("li[data-media-id]")
					);
					const sourceSet = new Set(
						mediaGallerySourceItems.map((item) => item.dataset.mediaId)
					);
					const sourceMap = new Map(
						mediaGallerySourceItems.map((item, index) => [
							item.dataset.mediaId,
							{ item, index },
						])
					);
					return [mediaGallerySourceItems, sourceSet, sourceMap];
				};

				if (mediaGallerySource && mediaGalleryDestination) {
					let [mediaGallerySourceItems, sourceSet, sourceMap] =
						refreshSourceData();
					const mediaGalleryDestinationItems = Array.from(
						mediaGalleryDestination.querySelectorAll("li[data-media-id]")
					);
					const destinationSet = new Set(
						mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
					);
					let shouldRefresh = false;

					// add items from new data not present in DOM
					for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
						if (
							!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
						) {
							mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
							shouldRefresh = true;
						}
					}

					// remove items from DOM not present in new data
					for (let i = 0; i < mediaGallerySourceItems.length; i++) {
						if (
							!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
						) {
							mediaGallerySourceItems[i].remove();
							shouldRefresh = true;
						}
					}

					// refresh
					if (shouldRefresh)
						[mediaGallerySourceItems, sourceSet, sourceMap] =
							refreshSourceData();

					// if media galleries don't match, sort to match new data order
					mediaGalleryDestinationItems.forEach(
						(destinationItem, destinationIndex) => {
							const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

							if (sourceData && sourceData.index !== destinationIndex) {
								mediaGallerySource.insertBefore(
									sourceData.item,
									mediaGallerySource.querySelector(
										`li:nth-of-type(${destinationIndex + 1})`
									)
								);

								// refresh source now that it has been modified
								[mediaGallerySourceItems, sourceSet, sourceMap] =
									refreshSourceData();
							}
						}
					);
				}

				// set featured media as active in the media gallery
				this.querySelector(`media-gallery`)?.setActiveMedia?.(
					`${this.dataset.section}-${variantFeaturedMediaId}`,
					true
				);

				// update media modal
				const modalContent = this.productModal?.querySelector(
					`.product-media-modal__content`
				);
				const newModalContent = html.querySelector(
					`product-modal .product-media-modal__content`
				);
				if (modalContent && newModalContent)
					modalContent.innerHTML = newModalContent.innerHTML;
			}

			setQuantityBoundries() {
				const data = {
					cartQuantity: this.quantityInput.dataset.cartQuantity
						? parseInt(this.quantityInput.dataset.cartQuantity)
						: 0,
					min: this.quantityInput.dataset.min
						? parseInt(this.quantityInput.dataset.min)
						: 1,
					max: this.quantityInput.dataset.max
						? parseInt(this.quantityInput.dataset.max)
						: null,
					step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
				};

				let min = data.min;
				const max = data.max === null ? data.max : data.max - data.cartQuantity;
				if (max !== null) min = Math.min(min, max);
				if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

				this.quantityInput.min = min;

				if (max) {
					this.quantityInput.max = max;
				} else {
					this.quantityInput.removeAttribute("max");
				}
				this.quantityInput.value = min;

				publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
			}

			fetchQuantityRules() {
				const currentVariantId = this.productForm?.variantIdInput?.value;
				if (!currentVariantId) return;

				this.querySelector(
					".quantity__rules-cart .loading__spinner"
				).classList.remove("hidden");
				fetch(
					`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
				)
					.then((response) => response.text())
					.then((responseText) => {
						const html = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.updateQuantityRules(this.dataset.section, html);
					})
					.catch((e) => console.error(e))
					.finally(() =>
						this.querySelector(
							".quantity__rules-cart .loading__spinner"
						).classList.add("hidden")
					);
			}

			updateQuantityRules(sectionId, html) {
				if (!this.quantityInput) return;
				this.setQuantityBoundries();

				const quantityFormUpdated = html.getElementById(
					`Quantity-Form-${sectionId}`
				);
				const selectors = [
					".quantity__input",
					".quantity__rules",
					".quantity__label",
				];
				for (let selector of selectors) {
					const current = this.quantityForm.querySelector(selector);
					const updated = quantityFormUpdated.querySelector(selector);
					if (!current || !updated) continue;
					if (selector === ".quantity__input") {
						const attributes = [
							"data-cart-quantity",
							"data-min",
							"data-max",
							"step",
						];
						for (let attribute of attributes) {
							const valueUpdated = updated.getAttribute(attribute);
							if (valueUpdated !== null) {
								current.setAttribute(attribute, valueUpdated);
							} else {
								current.removeAttribute(attribute);
							}
						}
					} else {
						current.innerHTML = updated.innerHTML;
					}
				}
			}

			get productForm() {
				return this.querySelector(`product-form`);
			}

			get productModal() {
				return document.querySelector(`#ProductModal-${this.dataset.section}`);
			}

			get pickupAvailability() {
				return this.querySelector(`pickup-availability`);
			}

			get variantSelectors() {
				return this.querySelector("variant-selects");
			}

			get relatedProducts() {
				const relatedProductsSectionId = SectionId.getIdForSection(
					SectionId.parseId(this.sectionId),
					"related-products"
				);
				return document.querySelector(
					`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
				);
			}

			get quickOrderList() {
				const quickOrderListSectionId = SectionId.getIdForSection(
					SectionId.parseId(this.sectionId),
					"quick_order_list"
				);
				return document.querySelector(
					`quick-order-list[data-id^="${quickOrderListSectionId}"]`
				);
			}

			get sectionId() {
				return this.dataset.originalSection || this.dataset.section;
			}
		}
	);
}
